
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p className='intro'>
  William W. muss sich heute vor Gericht verantworten. Schon wieder. Diesmal soll sich der einschlägig Vorbestrafte an
  fünf Kindern zwischen 4 und 13 Jahren vergangen haben ‒ in einer Kirche, im eigenen Restaurant, in der Wohnung von
  Freunden. Der 46-jährige Schweizer bestritt die Anschuldigungen bisher. Mehrfache Schändung, sexuelle Handlungen mit
  Kindern und sexuelle Nötigung wirft ihm die Solothurner Staatsanwaltschaft vor. Genau wegen solcher Straftaten wurde
  W. schon mehrmals verurteilt.
    </p>
    <p className='intro'>
  Eine vom Tamedia Recherchedesk zusammengestellte Chronologie, erstmals publiziert im letzten Februar, zeigt: Der
  gebürtige Kolumbianer missbrauchte schon ab 1994 Minderjährige. Er kam nur dank einer Formalie auf freien Fuss. Die
  Solothurner Behörden begleiteten ihn zwar eng, liessen ihn aber trotz Regelverstössen gewähren. Obwohl alle von seiner
  Gefährlichkeit wussten.
    </p>
    <Image source='Unter Verdacht: William W. muss sich erneut vor Gericht verantworten. (Facebook)' file={require('images/William_start.jpg')} mdxType="Image" />
    <p className='intro'>
  Der Artikel beruht auf der Anklageschrift, Gutachten, Gerichtsakten. Vor allem aber auf einem geheimen
  Untersuchungsbericht, den die Solothurner Regierung in Auftrag gegeben hatte. Er dokumentiert, wie die Behörden nicht
  auf böse Vorzeichen reagierten. Und keine Konsequenzen erfolgten, selbst als sich William W. ohne seine GPS-Fussfessel
  ins Ausland absetzte.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;